<div #Tooltip class="cb-tooltip-container" [class.cb-hidden]="!content()"
    [ngClass]="'cb-tooltip-position-'+position()+' cb-tooltip-align-'+alignment()" [style.left.px]="leftPosition()"
    [style.top.px]="topPosition()" [class.cb-tooltip-dark]="style() == 'dark'">
    <h6>{{content()}}</h6>
    @if(description()){
    <p>{{description()}}</p>
    }
</div>